function getCookie(name) {
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}


var _ASSET_BASE = 'https://jones-app.rndpxl.net/';
var assetCookie = getCookie('_ASSET_BASE');
if (assetCookie)
{
 	_ASSET_BASE = assetCookie; 
}

var scriptSrc = _ASSET_BASE + 'js/storefront.js';
var script = document.createElement('script');
script.id = "remote-script";
script.src = scriptSrc;
document.getElementsByTagName('head')[0].appendChild(script);


$('button').on('click',function(e) {
    if ($(this).hasClass('grid')) {
        $('.grid--view-items').removeClass('list').addClass('grid');
    }
    else if($(this).hasClass('list')) {
        $('.grid--view-items').removeClass('grid').addClass('list');
    }
});

var cartQuantity = function(variantID)
{
 if (!window.hasOwnProperty('_cart') || window._cart.item_count < 1)
 {
 	return 0; 
 }
  
  var items = window._cart.items;
  
  for (var i = 0; i < items.length; i++)
  {
    var item = items[i];
   if (item.variant_id == variantID)
   {
    	return item.quantity; 
   }
  }
  
  return 0;
}

var abbreviateSize = function(size)
{
	var s = size.toLowerCase();
  
    switch(s)
    {
      case 'extra small':
      case 'x small':
      case 'x-small':
        return 'XS';
        
      case 'small':
        return 'S';
        
      case 'medium':
        return 'M';
        
      case 'large':
        return 'L';
        
      case 'extra large':
      case 'x large':
      case 'xlarge':
      case 'x-large':
        return 'XL';
        
      case '2x large':
      case '2xlarge':
      case '2x-large':
        return '2XL';
        
      case '3x large':
      case '3xlarge':
      case '3x-large':
        return '3XL';
        
      case '4x large':
      case '4xlarge':
      case '4x-large':
        return '4XL';
        
      case '5x large':
      case '5xlarge':
      case '5x-large':
        return '5XL';
        
    }
  
  return size;

};


// var _APIBASE = 'https://jones-tshirts.local';
var _APIBASE = 'https://jones-app.rndpxl.net';

$(document).ready(function()
{
  	// PDP
	if (window.hasOwnProperty('_product') && (typeof window._product == 'object'))
    {

        var v = window._product.variants;
      	var colorData = window._colors.colors;
      	var sizeData = window._sizes.sizes;
      	var container = $('.variant-frame');
      
      	if (!container.length)
        {
          return;
        }
      
      
      
      	var getColor = function(colorName)
        {
          for (var c = 0; c < colorData.length; c++)
          {
           	var color = colorData[c];
            if (color.t == colorName)
            {
             return color; 
            }
          }
          
          return null;
        };
      
      
      var getSize = function(sizeName)
        {
          for (var s = 0; s < sizeData.length; s++)
          {
           	var size = sizeData[s];
            if (size.t == sizeName)
            {
             return size; 
            }
          }
          
          return null;
        };
      
      
      
      
      
      var getVariantsForColor = function(color)
      {
        var variants = [];
        for(var vi = 0; vi < v.length; vi++)
        {
         	var variant = v[vi];
          
          	if (variant.c == color)
            {
              	variants.push(variant);
            }
        }
        
        return variants;
      }
      
      var findVariantImage = function(color)
      {
        var vimgs = window._variantImages || [];
       	for (var i = 0; i < vimgs.length; i++)
        {
          var vi = vimgs[i];
          var img_color = vi.color.replace(':collection-default','');
          
          if (img_color == color)
          {
           return vi.src; 
          }
        }
        
        return null;
      }
      
      
      var updateMainImage = function(src, colorName)
      {
        $('.product-gallery--image img').prop({'src': src});
        $('.product-gallery--image a').prop({'href': src});
       
        
        if (typeof colorName !== 'undefined')
        {
         $('.product-gallery--image .color-name').text(colorName).show(); 
        }
        else 
        {
          $('.product-gallery--image .color-name').text('').hide(); 
        }
      }
      
      
      $('body').on('click', '.product-gallery--thumbnail-trigger', function(e)
	  {
      	e.preventDefault();
        var src = $(this).data('src');
        updateMainImage(src);
      });
      
      var swatches = container.find('.swatch-row');
      var colorSelect = container.find('[name="color-option"]');
      
      for(var c = 0; c < colorData.length; c++)
      {
        
        var color = colorData[c];
        
        var a = $('<a />');
        a.prop('class', 'swatch');
        a.prop('href', '#');
        a.css('background', '#' + color.h);
        a.attr('data-color', color.t);
        
        a.appendTo(swatches);
        
        var option = $('<option />');
        option.val(color.t);
        option.text(color.t + (color.o ? ' +$' + parseFloat(color.o).toFixed(2) : ''));
        colorSelect.append(option);
      }
      
      var colorSelectReset = colorSelect.clone();
      
      
      container.on('setup-variants', '.prices', function(e, color)
      {
        var sizeContainer = $(this);
        var colorVariants = getVariantsForColor(color);
        

        for(var v = 0; v < colorVariants.length; v++)
        {
          var variant = colorVariants[v];
          var sizeDiv = $('<div class="grid__item medium-up--one-eighth variant-input"></div>');
          sizeDiv.append('<span class="price-offset">&nbsp;</span>');
          var sn = $('<div class="size-name"></div>');
          sn.text(abbreviateSize(variant.s));
          
          var maxQty = Math.max(0, variant.a - cartQuantity(variant.id));
          
          var si = $('<input type="number" pattern="[0-9]*" value="" min="0" max="' + maxQty + '">');
          si.prop('name', 'variant[' + variant.id + ']');
          
          sizeDiv.append(sn).append(si);
          
          var size = getSize(variant.s);
          if (size && size.o)
          {
            var priceOffset = $('<span class="price-offset"></span>');
            priceOffset.text('+$' + parseFloat(size.o).toFixed(2));
            sizeDiv.append(priceOffset);
          }
          
          sizeDiv.appendTo(sizeContainer);
          
        }
        
      });
      
      container.on('change-color', function(e, color)
      {
        
        // Find Color Object
        var colorO = getColor(color);

        if (!colorO)
        {
         return; 
        }
        
        container.trigger('show-color-image', color);
        
        // Handle color selection
        swatches.find('.active').removeClass('active');
        swatches.find('[data-color="' + color + '"]').addClass('active');
        
        
        var latestVariant = $('.selected-variants').find('.variant:last');
        var allEmpty = true;
       

        latestVariant.find('.prices input').each(function()
        {
          	var val = $.trim($(this).val());
        	if (val != '' && val != '0')
            {
             	allEmpty = false;
              	return false;
            }
        });
        

        if (!allEmpty)
        {
        	var newVariant = latestVariant.clone();
          	newVariant.insertAfter(latestVariant);
        }
        else
        {
        	newVariant = latestVariant; 
        }
        
        
        
        colorSelect = newVariant.find('[name="color-option"]');
        
        if (colorSelect.val() != color)
        {
          colorSelect.val(color);
        }
        
        var sizeContainer = newVariant.find('.text-boxes .prices');
        
        sizeContainer.empty();
        newVariant.find('.selected-color-swatch').css('background', '#' + colorO.h);
        
        
        sizeContainer.trigger('setup-variants', color);
        container.trigger('update-selects');
        
      });
      

      // Clicking on a color swatch
      swatches.on('click', 'a:not(.disabled)', function(e)
      {
      	e.preventDefault();
        var color = $(this).data('color');
        container.trigger('change-color', color);
      });
      

      
      
      container.on('change', '[name="color-option"]', function()
      {
      	var color = $(this).val();
        var colorO = getColor(color);
                
        if (!colorO)
        {
        	return; 
        }
        
        
       	var sizeContainer = $(this).closest('.variant').find('.text-boxes .prices');
        
        sizeContainer.empty();
        $(this).closest('.variant').find('.selected-color-swatch').css('background', '#' + colorO.h);
       
        sizeContainer.trigger('setup-variants', color);
        container.trigger('update-selects');
        container.trigger('show-color-image', color);
      });
      
      
      // Removes a color block
      container.on('click', '.remove', function(e)
      {
      	e.preventDefault();
        $(this).closest('.variant').remove();
        container.trigger('update-selects');
      });
      
      
      // Adds a color box
      $('[data-add-additional-color]').on('click', function(e)
      {
      	e.preventDefault();
        var latestVariant = $('.selected-variants').find('.variant:last');
        var allVariants = $('.selected-variants');
      	var newVariant = latestVariant.clone();
        
        $('option', newVariant).filter(function(i) {
          return allVariants.find('option:selected[value="' + $(this).val() + '"]').length;
      	}).remove();
        
       	newVariant.insertAfter(latestVariant);
        newVariant.find('select').trigger('change');
        container.trigger('update-selects');
      });
      
      
      // Remove error states on value update
      container.on('change', '.variant-input input', function()
      {
      	$(this).removeClass('error');  
      });
      
      
      // Removes used colors from selects
      container.on('update-selects', function()
      {
      	var usedColors = [];
        //var remainingColors = colorData;
        container.find('.variant').each(function()
        {
          var select = $(this).find('select');
          var currentVal = select.val();
          usedColors.push(currentVal);
        });
        
        container.find('.variant').each(function()
        {
          var oldSelect = $(this).find('select');
          var currentVal = oldSelect.val();
          
          var select = colorSelectReset.clone();
          
          oldSelect.replaceWith(select);
          select.val(currentVal);
          
          for(var c = 0; c < usedColors.length; c++)
          {
           var color = usedColors[c];
            if (color != currentVal)
            {
             select.find('option[value="' + color + '"]').remove(); 
            }
              
          }
        });
        
        container.find('.swatch-row .swatch').each(function()
        {
        	var c = $(this).data('color');
            if (usedColors.indexOf(c) > -1)
            {
              $(this).addClass('disabled'); 
            }
            else
            {
              $(this).removeClass('disabled');
            }
        });
        
        // Hide/Show the Add button
        var add = $('[data-add-additional-color]');
        if (usedColors.length >= colorData.length)
        {
          
          add.hide();
        }
        else
        {
        	add.show();
        }
      })
      .trigger('update-selects');
      
      
            
      // Select default to start
      if (window.hasOwnProperty('_defaultColor'))
      {
       	if (window._defaultColor != '')
        {
        	container.trigger('change-color', window._defaultColor);
        }
      }
      
      
      // Switching image to color
      container.on('show-color-image', function(e, color)
      {
       	var img = findVariantImage(color);
        if (img)
        {
         updateMainImage(img, color); 
        }
      });
      
      
      // Validate entries and add to cart if okay
      $('[data-add-to-cart]').on('click', function(e)
      {
      	e.preventDefault();
        
        $('.validation-errors').empty();
        
        
        // Cycle through each set of selected items
        var atc = [];
        var errors = false;
        var variantErrors = [];
        
        container.find('.variant').each(function()
        {
          variantErrors = [];
          
          $(this).find('[name*="variant"]').each(function()
          {
            var qty = parseInt($(this).val()) || 0;

            if (qty <= 0)
            {
              return true; // continue
            }

            var max = parseInt($(this).prop('max'));
            
            if (qty > max)
            {
            	errors = true;
              	variantErrors.push({ input: $(this), size: $.trim($(this).parent().find('.size-name').text()), qty: qty, max: max });
            }

            var matches = $(this).prop('name').match(/variant\[([0-9]+)\]/);
            if (matches.length == 2)
            {
              var variantID = matches[1];
              atc.push({ id: variantID, quantity: qty });
            }
          });
          
          if (variantErrors.length)
          {
           	var ve = $(this).find('.validation-errors');
            ve.empty();
            var p = $('<p></p>');
            p.text('The highlighted quantities exceed current stock - please adjust to checkout.');
            
            for(var v = 0; v < variantErrors.length; v++)
            {
              var ver = variantErrors[v];
              p.append('<span><strong>' + ver.size + '</strong>: ' + ver.qty + ' (max ' + ver.max + ')</span>');
              ver.input.addClass('error');
            }
            
            p.appendTo(ve);
            
          }
        });
        
        
        if (errors)
        {
         	return false; 
        }
        
        
        if (atc.length)
        {
         for (var a = 0; a < atc.length; a++)
         {
           var item = atc[a];
           
           $.ajax({
             url: '/cart/add.js',
             async: false,
             type: 'POST',
             dataType: 'json',
             data: item,
             success: function(dta)
             {
              // 
               //console.info(dta);
             }
           });
         }
        }
        
        window.location = '/cart';
      });

    }
  
  
  
  return;
  var collectionQuery = function(items)
  {
    var queryString = '';

    for(var i = 0; i < items.length; i++)
    {
      	var item = items[i];
     	queryString += item.key + '=' + item.value;
      
      if (i < items.length - 1)
      {
       	queryString += '&'; 
      }
    }
    
    return queryString;
    
  }
  
  var hasResults = function(property, obj)
  {
    if (typeof obj == 'object' && obj.hasOwnProperty(property) && obj[property])
    {
      return true;
    }
    
    return false;
  }
  
  
    var fillTemplate = function(template, values, type)
    {
      
      if (type == 'product')
      {
      	  values.handle = '/products/' + values.handle;
      }
      
      
      var item = $(template.clone().html());
      for (var prop in values)
      {
        if (!values.hasOwnProperty(prop))
        {
          continue;
        }

        
        
        var el = item.find('[data-value="' + prop + '"]');

//         console.info(el);
        if (el.length)
        {
          el.each(function()
          {
            if (prop == 'hex')
            {
              $(this).css('background-color', '#' + values[prop]);
            }
            else if ($(this).data('prop') == 'value')
            {
//               if ($(this).is(':checkbox'))
//               {
// //                 console.info($(this));
//                 var newName = type + '[' + values[prop] + ']';
// //                 console.info(newName);
//                 $(this).prop('name', newName);
//               }
//               else
//               {
                $(this).val(values[prop]); 
//               }
            }
            else if ($(this).data('prop') == 'html')
            {
              $(this).html(values[prop]); 
            }
            else
            {
             	$(this).prop($(this).data('prop'), values[prop]); 
            }
          });
          
        }
        
      }
      
      return item;
    }
    
    
    var filters = [];
    var collectFilters = function()
    {
      filters = [];
      $('aside.sidebar').find('input:selected, input:checked').each(function()
      {
        if ($(this).is(':checkbox'))
        {
          filters.push({ key: $(this).prop('name') + '[]', value: $(this).val() });
        }
        else
        {
          filters.push({ key: $(this).prop('name'), value: $(this).val() });
        }
      });
      
      return filters;
    }
    
    
    var loadNewProducts = function(products)
    {
      var productGrid = $('.productgrid--items');
      productGrid.empty();
      
      for(var p in products)
      {
       if (!products.hasOwnProperty(p))
       {
           continue;
       }
           
        var product = products[p];
        var template = $('[data-product-template]');
        
        var filled = fillTemplate(template, product, 'product');
        
      
        productGrid.append(filled);
      
      }
 
    }
    
    
    var loadNewFilters = function(newFilters, existingSelections)
    {
      $('#filter-container').find('> li:not(:first)').remove();
      
      // Loop over each option type
      for(var r in newFilters)
      {

        if (!newFilters.hasOwnProperty(r))
        {
          continue;
        }
        
        if (r == 'tag-filters')
        {
          // Tag-based filters
          console.log(r, newFilters[r]);
          
          for (var t in newFilters[r])
          {
             // Regular Filters
            var container = $($('[data-template-type="filter-section"]').html());
            container.find('[data-prop="name"]').html(t);
            container.attr('data-filter', t);

            var ul = container.find('ul');

            var template = $('[data-template-type="' + t + '"]');
            if (!template.length)
            {
                template = $('[data-template-type="generic"]');
            }

  //           var template = template;
            var options = newFilters[r][t];

            for (var k in options)
            {
              if (!options.hasOwnProperty(k))
              {
                  continue; 
              }

              var li = fillTemplate(template, { name: k }, t);

              li.find('input').prop('name', 'tag-filters[' + t + ']');
              ul.append(li);
            }

            $('#filter-container').append(container); 
          }
          
        }
        else
        {
          
          // Regular Filters
          var container = $($('[data-template-type="filter-section"]').html());
          container.find('[data-prop="name"]').html(r);
          container.attr('data-filter', r);
          
          var ul = container.find('ul');

          var template = $('[data-template-type="' + r + '"]');
          if (!template.length)
          {
              template = $('[data-template-type="generic"]');
          }

//           var template = template;
          var options = newFilters[r];
        
          for (var k in options)
          {
            if (!options.hasOwnProperty(k))
            {
             	continue; 
            }
            
            var li;
            if (r == 'color')
            {
              li = fillTemplate(template, { name: k, hex: options[k].hex }, r);
            }
            else
            {
              li = fillTemplate(template, { name: k }, r);
            }
            
            li.find('input').prop('name', r);
            ul.append(li);
          }
          
          $('#filter-container').append(container);
        }
      }
      
      
      var existingContainer = $('.productgrid--filters');
      existingContainer.empty();
      var eul = $('<ul class="filter-group--grid"></ul>');
      eul.appendTo(existingContainer);
      
      for(var s in existingSelections)
      {

        if (!existingSelections.hasOwnProperty(s))
        {
          continue;
        }
      
        
        
        if (s == 'tag-filters')
        {
          for (var tf in existingSelections[s])
          {
            var selection = existingSelections[s][tf];
           if (!existingSelections[s].hasOwnProperty(tf))
           {
            continue; 
           }
            
            var filterContainer = $('[data-filter="' + tf + '"]');
        

            if (!filterContainer.length)
            {
              continue;
            }

            if (typeof selection == 'object')
            {
                for (var i = 0; i < selection.length; i++)
                {
                  var val = selection[i];
                  var input = filterContainer.find('input[value="' + val + '"]');
                  if (input.length)
                  {
                   input.prop('checked', true);
                  }
                }
            }


            var eTitle = tf + ': ' + existingSelections[s][tf];
            var eLink = '<li class="filter-item--grid">' +
                        '<a href="#" data-filter="tag-filters[' + tf + ']" data-value="' + existingSelections[s][tf] + '">' +
                          '<span class="filter-text">' + eTitle + '</span>' +
                          '<span class="filter-icon--remove">&times;<span class="show-for-sr">Remove filter</span></span>' +
                        '</a>' +
                    '</li>';

            eul.append(eLink);
          }
        }
        else
        {
          
          var selection = existingSelections[s];
          var filterContainer = $('[data-filter="' + s + '"]');
        

          if (!filterContainer.length)
          {
            continue;
          }

          if (typeof selection == 'object')
          {
              for (var i = 0; i < selection.length; i++)
              {
                var val = selection[i];
                var input = filterContainer.find('input[value="' + val + '"]');
                if (input.length)
                {
                 input.prop('checked', true);
                }
              }
          }


          var eTitle = s + ': ' + existingSelections[s];
          var eLink = '<li class="filter-item--grid">' +
                      '<a href="#" data-filter="' + s + '" data-value="' + existingSelections[s] + '">' +
                        '<span class="filter-text">' + eTitle + '</span>' +
                        '<span class="filter-icon--remove">&times;<span class="show-for-sr">Remove filter</span></span>' +
                      '</a>' +
                  '</li>';

          eul.append(eLink);
        }
        
        
      }

      
      
    }
  
    
  	// COLLECTION
  	if ($('aside.sidebar').length)
    {
      var filters = [];
      var wlh = window.location.href.replace(/\/$/, '');
      var collection = wlh.substring(wlh.lastIndexOf('/') + 1);
      
      // Get types on page load
      var typeTemplate = $($('[data-template-type="type"]').html());


      $.ajax({
        url: _APIBASE + '/filter?' + collectionQuery([ { key: 'collection', value: collection } ]),
        dataType: 'json',
        type: 'GET',
        success: function(response)
        {
        	if (hasResults('types', response))
            {
              var ul = $('ul[data-filter-prop="type"]');
              ul.empty();
              for(var t = 0; t < response.types.length; t++)
              {
               	var type = response.types[t];
                var li = fillTemplate(typeTemplate, { name: type }, 'type');
                ul.append(li);
              }
            }
          else
          {
           	console.error('API FILTERING ERROR'); 
          }
      	},
        error: function(err, e2)
        {
			console.error('API Filtering error [x1]');
        }
      });
      
      
      
      $(this).on('change', 'input', function()
	  {
      	var filters = collectFilters();
        filters.push({ key: 'collection', value: collection });
        
        
        $.ajax({
          url: _APIBASE + '/filter?' + collectionQuery(filters),
          dataType: 'json',
          type: 'GET',
          success: function(response)
          {
            if (hasResults('options', response))
            {
              loadNewProducts(response.products);
              
              if (hasResults('products', response))
              {
               loadNewFilters(response.options, response.selections); 
                $('html, body').animate({ scrollTop: 0 }, 500);
              }
            }
            else
            {
              console.error('API FILTERING ERROR'); 
            }
          },
          error: function(err, e2)
          {
              console.error('API Filtering error [x2]');
          }
        });
        
      });
      
      $('.productgrid--filters').on('click', 'a', function(e)
      {
        e.preventDefault();
        
      	var property = $(this).data('filter');
        var value = $(this).data('value');
        
        $('#filter-container').find('input[name="' + property + '"][value="' + value + '"]').prop('checked', false).trigger('change');
        $(this).closest('li').remove();
        
        //console.info(property, value);
      });
      
    }
});